<div class="xi-modal__container user-add__container" *transloco="let t">
  @if (currentStep === 1) {
    <h2 class="xi-modal__title user-add__title">{{ t('user-add-dialog.title') }}</h2>
    <h4 class="user-add__subtitle">
      {{ t('user-add-dialog.subtitle') }}
    </h4>
    <div class="xi-modal__content user-add__radio-group-container">
      <mat-radio-group class="user-add__radio-group" [(ngModel)]="selectedPermission">
        @for (radio of permissionRadios; track radio) {
          <mat-radio-button [value]="radio.value">
            {{ radio.displayName }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
    <div class="xi-modal__actions">
      <xi-default-button
        text="{{ t('user-add-dialog.cancel') }}"
        fill="text"
        (onClick)="cancel()"
      ></xi-default-button>
      <div class="xi-loader-button-container">
        <xi-default-button
          text="{{ t('user-add-dialog.next') }}"
          (onClick)="this.currentStep = 2"
        ></xi-default-button>
        @if (isSaving) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>
    </div>
  }
  @if (currentStep === 2) {
    <h2 class="xi-modal__title user-add__title">
      {{ t('user-add-dialog.add-users') }} - {{ getDisplayName(selectedPermission) }}
    </h2>
    <h4 class="user-add__subtitle">{{ t('user-add-dialog.add-users-subtitle') }}</h4>
    <div class="xi-modal__content">
      <div>
        <table
          mat-table
          [dataSource]="allUsersDs"
          matSort
          matSortActive="email"
          matSortDirection="asc"
          matSortDisableClear
          class="full-width"
        >
          <ng-container matColumnDef="add">
            <th mat-header-cell *matHeaderCellDef>{{ t('user-add-dialog.add-user') }}</th>
            <td mat-cell *matCellDef="let element">
              @if (element.email === 'Select All') {
                <mat-checkbox
                  [disabled]="isSaving"
                  [checked]="allComplete"
                  [indeterminate]="someComplete"
                  (change)="toggleAllUsers()"
                ></mat-checkbox>
              } @else {
                <mat-checkbox
                  [disabled]="isSaving"
                  [checked]="isUserSelected(element)"
                  (change)="toggleUser(element)"
                ></mat-checkbox>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ t('user-add-dialog.columns.email') }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.email }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ t('user-add-dialog.columns.name') }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.first_name }} {{ element.last_name }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20, 50, 100]"
      [pageSize]="10"
      showFirstLastButtons
      aria-label="Select page"
    >
    </mat-paginator>
    <div class="xi-modal__actions user-add__actions">
      <xi-default-button
        text="{{ t('user-add-dialog.back') }}"
        fill="text"
        (onClick)="back()"
      ></xi-default-button>
      <div class="xi-loader-button-container">
        <xi-default-button
          text="{{ t('user-add-dialog.add-users-button') }}"
          [disabled]="!canAddUsers()"
          (onClick)="add()"
        ></xi-default-button>
        @if (isSaving) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>
    </div>
  }
</div>
